import { useState, useEffect, useCallback } from "react";
import { get } from "@common/services/request";

export function useBrewEligibility() {
  // Fail open: assume the user may start a process until brew-eligibility/
  // says otherwise. The backend is the source of truth either way.
  const [brewEligible, setBrewEligible] = useState(true);
  const [nextBrewDate, setNextBrewDate] = useState(null);
  const [brewStats, setBrewStats] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const checkBrewEligibility = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const eligibilityResponse = await get("brew-eligibility/");
      if (eligibilityResponse) {
        setBrewEligible(eligibilityResponse.eligible !== false);
        setNextBrewDate(
          !eligibilityResponse.eligible && eligibilityResponse.next_brew_date
            ? eligibilityResponse.next_brew_date
            : null,
        );
      }
    } catch (err) {
      // Fail open: ignore error and keep brewEligible = true
      setError(err);
    }

    try {
      const statsResponse = await get("brew-stats/");
      if (statsResponse) {
        setBrewStats(statsResponse);
      }
    } catch (err) {
      // ignore
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    checkBrewEligibility();
  }, [checkBrewEligibility]);

  return {
    brewEligible,
    nextBrewDate,
    brewStats,
    loading,
    error,
    checkBrewEligibility,
    setBrewEligible,
    setNextBrewDate,
  };
}

export default useBrewEligibility;
